import { takeEvery, fork, put, all, call } from 'redux-saga/effects'

import fetch from './../../../fetch'
import {
  baseURL,
  commonHeaders,
} from './../../../../../Containers/Confiq/index'

import {
  GET_CATEGORY,
  GET_CATEGORY_SUCCESS,
  GET_CATEGORY_ERROR,
} from './../../../actionType'

function* getCategory({ payload }) {
  try {
    const response = yield call(fetch, {
      url: `http://localhost:8083/admin/categories`,
      method: 'GET',
      // headers: { ...commonHeaders },
    })

    console.log('mytestingResponse', response, response?.error)
    if (response?.error === undefined) {
      yield put({ type: GET_CATEGORY_SUCCESS, payload: response })
    } else {
      yield put({ type: GET_CATEGORY_ERROR, payload: response.error })
    }
  } catch (error) {
    yield put({ type: GET_CATEGORY_ERROR, payload: error })
  }
}

export function* watchGetCategory() {
  yield takeEvery(GET_CATEGORY, getCategory)
}

function* getCategorySaga() {
  yield all([fork(watchGetCategory)])
}

export default getCategorySaga
